// copied directly from https://tabulator.info/examples/6.4#filter-header

//custom max min header filter
var minMaxFilterEditor = (cell, _onRendered, success, cancel, _editorParams) => {
  var end;

  var container = document.createElement("span");

  //create and style inputs
  var start = document.createElement("input");
  start.setAttribute("type", "number");
  start.setAttribute("placeholder", "Min");
  start.setAttribute("min", 0);
  start.setAttribute("max", 100);
  start.style.padding = "4px";
  start.style.width = "50%";
  start.style.boxSizing = "border-box";

  start.value = cell.getValue();

  function buildValues() {
    if (!start.value && start.value !== 0 && !end.value && end.value !== 0) {
      cell.getColumn().setHeaderFilterValue(null);
    } else {
      success({
        start: start.value,
        end: end.value,
      });
    }
  }

  function keypress(e) {
    if (e.keyCode === 13) {
      buildValues();
    }

    if (e.keyCode === 27) {
      cancel();
    }
  }

  end = start.cloneNode();
  end.setAttribute("placeholder", "Max");

  start.addEventListener("change", buildValues);
  start.addEventListener("blur", buildValues);
  start.addEventListener("keydown", keypress);

  end.addEventListener("change", buildValues);
  end.addEventListener("blur", buildValues);
  end.addEventListener("keydown", keypress);

  container.appendChild(start);
  container.appendChild(end);

  return container;
};

//custom max min filter function
function minMaxFilterFunction(headerValue, rowValue, _rowData, _filterParams) {
  //headerValue - the value of the header filter element
  //rowValue - the value of the column in this row
  //rowData - the data for the row being filtered
  //filterParams - params object passed to the headerFilterFuncParams property

  if (rowValue) {
    if (headerValue.start !== "") {
      if (headerValue.end !== "") {
        return rowValue >= headerValue.start && rowValue <= headerValue.end;
      } else {
        return rowValue >= headerValue.start;
      }
    } else {
      if (headerValue.end !== "") {
        return rowValue <= headerValue.end;
      }
    }
  }

  return true; //must return a boolean, true if it passes the filter.
}

var dateRangeEditor = (_cell, _onRendered, success, cancel, _editorParams) => {
  // Helper to create an input (reusable for start and end)
  const createDateInputWrapper = (name, placeholder) => {
    const input = document.createElement("input");
    input.name = name;
    input.type = "text";
    input.placeholder = placeholder;
    input.className =
      "block w-full bg-neutral-secondary-medium border border-default-medium text-heading text-sm rounded-base focus:ring-brand focus:border-brand placeholder:text-body pr-1!";

    return input;
  };

  // Date range picker from Flowbite
  const dateRangePicker = document.createElement("div");
  dateRangePicker.setAttribute("date-rangepicker", "");
  dateRangePicker.setAttribute("datepicker-format", "yyyy-mm-dd");
  dateRangePicker.className = "flex items-center";

  const startInput = createDateInputWrapper("start", "Start");
  const endInput = createDateInputWrapper("end", "End");

  let sendTimer;
  function buildValues(e) {
    e.stopPropagation();

    if (startInput.value && endInput.value && startInput.value !== endInput.value) {
      clearTimeout(sendTimer);
      sendTimer = setTimeout(() => {
        const datePickerWidget = document.querySelector(
          ".datepicker.datepicker-dropdown:not(.hidden)",
        );

        if (datePickerWidget) {
          datePickerWidget.classList.add("hidden");
        }

        success({
          start: startInput.value,
          end: endInput.value,
        });
      }, 600);
    }
  }

  function keypress(e) {
    e.stopPropagation();
    if (e.keyCode === 13) {
      buildValues(e);
    }

    if (e.keyCode === 27) {
      cancel();
    }
  }

  startInput.addEventListener("changeDate", buildValues);
  startInput.addEventListener("keydown", keypress);

  endInput.addEventListener("changeDate", buildValues);
  endInput.addEventListener("keydown", keypress);

  dateRangePicker.appendChild(startInput);
  dateRangePicker.appendChild(endInput);

  return dateRangePicker;
};

function dateRangeFilterFunction(headerParams, rowValue, _rowData, _filterParams) {
  // Convert rowValue to a date object if it isn't one
  var rowDate = new Date(rowValue);

  if (headerParams.start && headerParams.end) {
    return rowDate >= headerParams.start && rowDate <= headerParams.end;
  } else if (headerParams.start) {
    return rowDate >= headerParams.start;
  } else if (headerParams.end) {
    return rowDate <= headerParams.end;
  }

  return true;
}

// Additions:

function percentFormatter(cell) {
  const value = parseFloat(cell.getValue());
  if (Number.isNaN(value)) {
    return "-";
  }

  return `${Math.round(parseFloat(cell.getValue()), 2)}%`;
}

function decimalFormatter(cell) {
  const value = parseFloat(cell.getValue());
  if (Number.isNaN(value)) {
    return "-";
  }

  let newValue = value;
  if (value >= 1) {
    newValue = value.toFixed(2);
  } else {
    newValue = value.toFixed(6).replace(/\.?0+$/, "");
  }
  // Split number into whole and fractional parts
  let [whole, fraction] = newValue.toString().split(".");
  // Add commas to whole part only
  whole = whole.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // Rejoin whole and fractional parts
  newValue = fraction ? `${whole}.${fraction}` : whole;
  return newValue;
}

function humanizeExponentFormatter(cell) {
  const value = parseFloat(cell.getValue());
  if (Number.isNaN(value)) {
    return "-";
  }

  let newValue = value;
  let unit = "";

  if (value >= 1000000) {
    newValue = value / 1000000;
    unit = "T";
  } else if (value >= 1000) {
    newValue = value / 1000;
    unit = "B";
  } else if (value >= 1) {
    newValue = value;
    unit = "M";
  } else if (value >= 0.001) {
    newValue = value * 1000;
    unit = "K";
  } else {
    newValue = value * 1000000;
    unit = "K";
  }
  return newValue.toFixed(2) + unit;
}

function smartRound(num, decimalPlaces) {
  return parseFloat(num).toFixed(decimalPlaces);
}

function smartRoundFormatter(cell) {
  const value = parseFloat(cell.getValue());

  if (Number.isNaN(value)) {
    return "-";
  }

  return smartRound(value, 2);
}

// Make it available globally
window.tabulatorHelpers = {};
window.tabulatorHelpers.minMaxFilterEditor = minMaxFilterEditor;
window.tabulatorHelpers.minMaxFilterFunction = minMaxFilterFunction;
window.tabulatorHelpers.dateRangeEditor = dateRangeEditor;
window.tabulatorHelpers.dateRangeFilterFunction = dateRangeFilterFunction;

window.tabulatorHelpers.smartRound = smartRound;

window.tabulatorHelpers.percentFormatter = percentFormatter;
window.tabulatorHelpers.decimalFormatter = decimalFormatter;
window.tabulatorHelpers.humanizeExponentFormatter = humanizeExponentFormatter;
window.tabulatorHelpers.smartRoundFormatter = smartRoundFormatter;
